import React, { useEffect, useState } from 'react';
import './Header.css';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    let ticking = false;
    
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const scrollTop = window.scrollY;
          setIsScrolled(scrollTop > 50);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerHeight = 80; // Account for fixed header
      const elementPosition = element.offsetTop - headerHeight;
      
      // Much smoother scrolling with better easing
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
    setIsMobileMenuOpen(false); // Close mobile menu after navigation
  };

  const scrollToTop = () => {
    // Smoother scroll to top
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    setIsMobileMenuOpen(false); // Close mobile menu after navigation
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo">
          <a href="#top" className="logo-link" onClick={scrollToTop}>
            <img src="https://assets.taar.ai/logo.png" alt="Taar AI" className="logo-image" />
          </a>
        </div>

        <nav className="nav-links">
          <a href="#top" className="nav-link" onClick={scrollToTop}>Home</a>
          <a href="#pricing" className="nav-link" onClick={() => scrollToSection('pricing')}>Pricing</a>
          <a href="https://docs.taar.ai" className="nav-link" target="_blank" rel="noopener noreferrer">Docs</a>
        </nav>

        <div className="nav-actions">
          <button className="sign-in-btn">Sign In</button>
        </div>

        <button 
          className={`mobile-menu-btn ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="mobile-menu-overlay">
          <nav className="mobile-nav-links">
            <a href="#top" className="mobile-nav-link" onClick={scrollToTop}>Home</a>
            <a href="#pricing" className="mobile-nav-link" onClick={() => scrollToSection('pricing')}>Pricing</a>
            <a href="https://docs.taar.ai" className="mobile-nav-link" target="_blank" rel="noopener noreferrer">Docs</a>
            <button className="mobile-sign-in-btn">Sign In</button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
